<template>
  <div class="user-content-section">
    <div class="user-shape-4">
      <div class="user-shape">
        <div class="user-shape-icons">
          <i class="fa-title shape-icon-bg"></i>
          <i class="fa-book shape-icon"></i>
        </div>
        <div class="user-shape-content">
          <b v-if="courses">{{ courses.paid_courses }}</b>
          <p>
            <span>{{ $t("purchased_courses") }}</span>
          </p>
        </div>
      </div>
      <div class="user-shape">
        <div class="user-shape-icons">
          <i class="fa-title shape-icon-bg"></i>
          <img
            src="../../assets/images/icon/play.svg"
            class="shape-icon"
            alt=""
          />
        </div>
        <div class="user-shape-content">
          <b v-if="courses">{{ courses.progress_courses }}</b>
          <p>
            <span>{{ $t("studying_courses") }}</span>
          </p>
        </div>
      </div>
      <div class="user-shape">
        <div class="user-shape-icons">
          <i class="fa-title shape-icon-bg"></i>
          <i class="fa-timer shape-icon"></i>
        </div>
        <div class="user-shape-content">
          <b v-if="courses">{{ courses.finished_courses }}</b>
          <p>
            <span>{{ $t("completed_courses") }}</span>
          </p>
        </div>
      </div>
      <div class="user-shape">
        <div class="user-shape-icons">
          <i class="fa-title shape-icon-bg"></i>
          <i class="fa-timer shape-icon"></i>
        </div>
        <div class="user-shape-content">
          <b v-if="courses">{{ courses.certificated_course }}</b>
          <p>
            <span>{{ $t("certificates") }}</span>
          </p>
        </div>
      </div>
    </div>
    <div class="user-recommendation">
      <div class="page-sub-title">
        <h2>
          <i class="fa-title"></i>
          <div>{{ $t("my_courses") }}</div>
        </h2>
      </div>
      <p class="recommendation-description" v-if="courses && !courses.result">
        <span>{{ $t("no_courses_started") }}</span>
      </p>

      <div class="courses-all-list" v-if="courses">
        <CoursesCard
          v-for="(item, index) in courses.result"
          :key="index"
          :data="item"
        />
      </div>
      <div class="courses-all-list" v-else>
        <v-loader />
      </div>
    </div>
    <!--    <div class="user-recommendation">-->
    <!--      <div class="my-courses">-->
    <!--        <div class="page-sub-title">-->
    <!--          <h2><i class="fa-title"></i>Мои собственные курсы</h2>-->
    <!--        </div>-->
    <!--        <a href="#">Добавить курс <i class="fa-arrow-down"></i></a>-->
    <!--      </div>-->

    <!--      <p class="recommendation-description">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.-->
    <!--        Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</p>-->
    <!--      <div class="courses-all-list">-->
    <!--        <CoursesCard :load="true" />-->
    <!--        <CoursesCard :load="true" />-->
    <!--        <CoursesCard :load="true" />-->
    <!--        <CoursesCard :load="true" />-->
    <!--        <CoursesCard :load="true" />-->
    <!--        <CoursesCard :load="true" />-->
    <!--      </div>-->
    <!--    </div>-->
  </div>
</template>

<script>
import CoursesCard from "@/components/CoursesCard";

export default {
  title: "Siz sotib olgan kurslar",
  async mounted() {
    await this.$store.dispatch("myCourses");
  },
  computed: {
    courses() {
      return this.$store.getters.getMyCourses;
    },
  },
  components: {
    CoursesCard,
  },
};
</script>
